module.exports = __webpack_public_path__ + "static/media/gift04_en.9cb37c41.png";